// PortalAuthGuard.js — Checks for ivaldi_session cookie from ivaldi-portal.ivaldi.io
// If absent, redirects to portal login with a redirect-back URL.

import { useEffect, useState } from 'react';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

export function PortalAuthGuard({ children }) {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (getCookie('ivaldi_session')) {
      setAllowed(true);
    } else {
      const redirect = encodeURIComponent(window.location.href);
      window.location.href = `https://ivaldi-portal.ivaldi.io/login?redirect=${redirect}`;
    }
  }, []);

  if (!allowed) return null;
  return children;
}
